import { useEffect, useState } from "react";
import { Route, Routes, useNavigate, useParams } from "react-router-dom";
import { StandardList } from "../../../_components/list/standardList.component";
import { StandardListItem } from "../../../_components/list/standardListItem.component";
import { getDate } from "../../../_helpers/dateTime.helper";
import { handleErrorResponse } from "../../../_helpers/handleResponse.helper";
import { FormStatusEnum } from "../../../_common/enum/forms/formStatus.enum";
import { accountService } from "../../../_services/accounts.service";
import { ticketActionService } from "../../../_services/ticketAction.service";
import { TicketActionDrawer } from "./ticket-actionDrawer";
import { TicketActionManage } from "./ticket-actionManage";

export function TicketActionList() {


    const { id } = useParams<{ id: string }>();
    const [isLoading, setIsLoading] = useState(true);
    const [data, setData] = useState<any[]>([]);
    const navigate = useNavigate();

    useEffect(() => {
        fetchData();
    }, [id]);

    function fetchData() {
        if (!id) return;
        setIsLoading(true);
        return ticketActionService
            .getAll(id)
            .then(
                (json) => {
                    setData(json);
                },
                handleErrorResponse
            )
            .finally(() => setIsLoading(false));
    }

    return (

        <>
            <StandardList isLoading={isLoading}>
                {(!isLoading && !!data.length) && data.map((item, index) => (
                    <StandardListItem
                        sx={{
                            backgroundColor: item.formStatusId === FormStatusEnum.CompletedAwaitingApproval
                                ? '#fff4ce'
                                : item.isPublic ? '#ffdddd' : '#f9f9f9',
                            '&:hover': {
                                backgroundColor: item.formStatusId === FormStatusEnum.CompletedAwaitingApproval
                                    ? '#ffe8a1'
                                    : item.isPublic ? '#f5bcbc' : '#f1f1f1',
                            },
                        }}
                        primary={item.actionType}
                        secondary={item.nextActionDate != null ? getDate(item.nextActionDate) : ""}
                        key={item.id}
                        buttons={[
                            { icon: item.isCompleted || accountService.isClient ? "visibility" : "edit", onClick: () => { navigate(`Action/${item.id}`) } },
                            // {icon: "delete", variant: "error", onClick: () => { disable(item.id) } },
                        ] }
                    
                    />
                ))}

            </StandardList>
            <Routes>
                    <Route path="Action/:actionId" element={<TicketActionDrawer onSave={() => { fetchData(); navigate(""); }} onClose={() => { navigate(""); }} />} />
           </Routes>

       </>
    );

}
